import React, {useContext} from "react"
import {BuahContext} from "./BuahContext"

const BuahList = () =>{
  const [buah, setBuah, name, setName, harga, setHarga, berat, setBerat, showForm, setShowForm, statusForm, setStatusForm, currentIndex, setCurrentIndex] = useContext(BuahContext)

  const handleEdit = (event) => {
    let index = Number(event.target.value)
    let currentDataBuah = buah[index]

    setStatusForm("edit")
    setCurrentIndex(index)
    setName(currentDataBuah.nama)
    setHarga(currentDataBuah.hargaTotal)
    setBerat(currentDataBuah.beratTotal)
    setShowForm(true)
}

const handleDelete = (event) => {
    let index = Number(event.target.value)
    if (currentIndex !== -1){
        setCurrentIndex(-1)
        setName("")
        setHarga()
        setBerat()
        setShowForm(false)
    }

    let newDataBuah = buah.filter((item) => {
        return item !== buah[index]
    })

    setBuah(newDataBuah)
}
  

  return(
    <>
    <h1 className="App">Daftar Buah</h1>
    <table className="custom-table">
    <thead>
        <tr>    
            <th>No</th>
            <th>Nama</th>
            <th>Harga Total</th>
            <th>Berat Total</th>
            <th>Harga per kg</th>
            <th>Aksi</th>
        </tr>
    </thead>
    <tbody>
    {buah.map((el, index)=>{
        return(
        <tr key={index}>
            <td>{index+1}</td>
            <td>{el.nama}</td>
            <td>{el.hargaTotal}</td>
            <td>{el.beratTotal/1000} kg</td>
            <td>{el.hargaTotal/(el.beratTotal/1000)}</td>
            <td>
                <button className="button-edit mr-10" onClick={handleEdit} value={index}>Edit</button>
                <button className="button-delete" onClick={handleDelete} value={index}>Delete</button>
            </td>
        </tr>    
            
        ) 
      })}

    </tbody>
    </table>
    </>
  )

}

export default BuahList